import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DataGrid } from '@mui/x-data-grid';

const useStyles = makeStyles(() => ({
  dataTable: {
    height: '52vh',
    marginBottom: 0,

    '& .MuiDataGrid-root': {
      backgroundColor: 'white',
    },
  },
}));

export default function BaseDataTable({
  columns,
  rows,
  style = {},
  pageSize = 10,
}) {
  const classes = useStyles();

  return (
    <div className={classes.dataTable} style={style}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={pageSize}
        rowsPerPageOptions={[pageSize]}
        disableSelectionOnClick
      />
    </div>
  );
}
